export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14273.e06dc225.jpg";